"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactQuery = require("react-query");

var _request = require("@nicbase/request");

var _queryKey = _interopRequireDefault(require("./queryKey"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var findAlarmsForPortal = function findAlarmsForPortal(portalId, dynamicPaging, dynamicSorters, dynamicFilters) {
  return {
    type: 'FIND_ALARMS_FOR_PORTAL_REQUEST',
    headers: {
      version: 'v1',
      portalId: portalId
    },
    body: {
      dynamicFilters: dynamicFilters,
      dynamicPaging: dynamicPaging,
      dynamicSorters: dynamicSorters
    }
  };
};

var usePortalAdminFindAlarms = function usePortalAdminFindAlarms(_ref) {
  var portalId = _ref.portalId,
      pageSize = _ref.pageSize,
      dynamicSorters = _ref.dynamicSorters,
      dynamicFilters = _ref.dynamicFilters;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  return (0, _reactQuery.useInfiniteQuery)([].concat(_toConsumableArray((0, _queryKey["default"])(portalId)), [{
    pageSize: pageSize,
    dynamicSorters: dynamicSorters,
    dynamicFilters: dynamicFilters
  }]), /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var _ref2$pageParam, pageNumber, _yield$request, body;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref2$pageParam = _ref2.pageParam, pageNumber = _ref2$pageParam === void 0 ? 0 : _ref2$pageParam;
              _context.next = 3;
              return request(findAlarmsForPortal(portalId, {
                pageNumber: pageNumber,
                pageSize: pageSize
              }, dynamicSorters, dynamicFilters));

            case 3:
              _yield$request = _context.sent;
              body = _yield$request.body;
              return _context.abrupt("return", body);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), _objectSpread({
    getNextPageParam: function getNextPageParam(lastPage, allPages) {
      if (pageSize === null || lastPage.alarms.length < pageSize) {
        return undefined;
      }

      return allPages.length;
    }
  }, options));
};

var _default = usePortalAdminFindAlarms;
exports["default"] = _default;